import React from 'react'
import '../assets/style/SoundBar.css'

const SoundBarView = ({ children }) => {
  return (
    <div>
      {/* Fixed Soundbar */}
      <div id='fixed-soundbar' className='soundbar' style={{ position: 'relative', width: '100%', marginTop: 10 }}>
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexWrap: 'wrap', }}>
          {children}
        </div>
      </div>
    </div>
  )
}

export default SoundBarView
